import { Button, message, Modal } from "antd";
import SucessImg from "assets/green_check.svg";
import { useSelectParticipants } from "features/notification/use-cases/update-partipantNotification";

type ActionModalProps = {
    open: boolean;
    actionType?: "Approve" | "Reject";
    selectedCount: number;
    totalCount: number;
    onConfirm?: () => void;
    onCancel?: () => void;
    updateParams?: (values: any) => void;
    tableParams?: any;
    setSelectedRowKeys: (keys: React.Key[]) => void;
};

export const NotificationModelSelected = ({
    open,
    totalCount,
    onConfirm,
    onCancel,
    tableParams,
    setSelectedRowKeys
}: ActionModalProps) => {
    const { mutate, isLoading } = useSelectParticipants()
    const handleConfirm = () => {
        const payload = {
            SessionId: sessionStorage.getItem("sessionId") || "",
            SportCategoryIds: tableParams?.SportCategoryIds ?? "",
            EventIds: tableParams?.EventIds ?? "",
            TicketCategoryIds: tableParams?.TicketCategoryIds ?? "",
            AgeGroupIds: tableParams?.AgeGroupIds ?? "",
            GenderId: tableParams?.GenderId ?? 0,
            Natioanlity: tableParams?.Natioanlity ?? "",
            CustomerName: tableParams?.CustomerName ?? "",
            emailId: tableParams?.emailId ?? "",
            paymentStatus: tableParams?.paymentStatus ?? 0,
        };
        mutate(payload, {
            onSuccess: (data:any) => {
                onConfirm?.();
                message.success(data?.responseMessage);
                setSelectedRowKeys([])
            },
            onError: (error:any) => {
                message.error(error?.responseMessage);
            },
        });
    };
    
return (
        <Modal
            open={open}
            footer={null}

            closable={false}
            centered
            width={420}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    padding: "16px 8px",
                }}
            >
                <img
                    src={SucessImg}
                    alt="Selected"
                    style={{
                        width: 72,
                        height: 72,
                        marginBottom: 20,
                    }}
                />

                <h2
                    style={{
                        marginBottom: 12,
                        fontSize: "22px",
                        fontWeight: 600,
                        color: "#262626",
                    }}
                >
                    Select  Participants
                </h2>

                <p
                    style={{
                        marginBottom: 8,
                        fontSize: "16px",
                        color: "#595959",
                    }}
                >
                   Are you sure you want to Move {totalCount} participants
                </p>

                {/* <p
                    style={{
                        marginBottom: 28,
                        fontSize: "15px",
                        color: "#8c8c8c",
                    }}
                >
                    {selectedCount === totalCount
                        ? `You have selected all ${totalCount} participants.`
                        : `You have selected ${totalCount} participant${totalCount > 1 ? "s" : ""
                        }.`}
                </p> */}

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 16,
                        width: "100%",
                    }}
                >
                    <Button
                        size="large"
                        onClick={onCancel}
                        style={{
                            minWidth: 120,
                            borderRadius: 8,
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        type="primary"
                        size="large"
                        loading={isLoading}
                        onClick={handleConfirm}
                        style={{
                            minWidth: 120,
                            borderRadius: 8,
                            background: "#333333",
                            borderColor: "#333333",
                        }}
                    >
                        Continue
                    </Button>
                </div>
            </div>
        </Modal>
    );
};